module.exports = __webpack_public_path__ + "media/images/icons/icon_soccer-ddac9cf5a1795d644f9047c3de952574.png";